import { Routes } from "@angular/router";
import { AppPage, AuthGuardService, AuthService } from "jk-service";
import { Utyjb01Component } from "./utyjb01/utyjb01.component";
import { Utyjb52Component } from "./utyjb52/utyjb52.component";
import { Utyji05Component } from "./utyji05/utyji05Pkg.component";
import { Utyq01Component } from "./utyq01/utyq01.component";
import { Utypq01Component } from "./utypq01/utypq01.component";
import { Utypi02BillComponent } from "./utypi02/utypi02BillPkg.component";
import { Utyji05BillComponent } from "./utyji05/utyji05BillPkg.component";
import { Utypi03BillComponent } from "./utypi03/utypi03BillPkg.component";
import { Utypq03Component } from "./utypq03/utypq03.component";

export const utyPages: AppPage[] = [
  {
    title: '資料匯出匯入formatter',
    url: '/uty/utyjb01',
    id: 'utyjb01',
    icon: '',
    isCheckPower: true,
  },
  {
    title: 'SSML文字轉語音',
    url: '/uty/utyjb52',
    id: 'utyjb52',
    icon: '',
    isCheckPower: false,
  },
  {
    title: '電腦/IP建立',
    url: '/uty/utyji05',
    icon: '',
    id: 'utyji05',
    isCheckPower: true,
  },
  {
    title: '萬用查詢建立',
    url: '/uty/utypi02',
    icon: '',
    id: 'utypi02',
    isCheckPower: true,
  },
  {
    title: '*萬用查詢建立',
    url: '/uty/utypi03',
    icon: '',
    id: 'utypi03',
    isCheckPower: true,
  },
  {
    title: '萬用查詢建立-pvi',
    url: '/uty/utyai01',
    icon: '',
    id: 'utyai01',
    isCheckPower: true,
  },
  {
    title: '萬用查詢',
    url: '/uty/utyq01',
    icon: 'git-network',
    id: 'utyq01',
    isCheckPower: true,
  },
  {
    title: '電腦/IP查詢',
    url: '/uty/utypq01',
    icon: 'git-network',
    id: 'utypq01',
    isCheckPower: true,
  },
  {
    title: '*萬用查詢',
    url: '/uty/utyq03',
    icon: 'git-network',
    id: 'utypq03',
    isCheckPower: true,
  },

];

export const utyRoutes: Routes = [
  {
    path: 'utyjb01',
    //loadComponent: () => import('./utyjb01/utyjb01.component').then(m => m.Utyjb01Component),
    component: Utyjb01Component,
  },
  {
    path: 'utyjb52',
    //loadComponent: () => import('./utyjb52/utyjb52.component').then(m => m.Utyjb52Component),
    component: Utyjb52Component,
  },
  {
    path: 'utyji05',
    //loadComponent: () => import('./utyji05/utyji05Pkg.component').then(m => m.Utyji05Component),
    component: Utyji05BillComponent,
  },
  {
    path: 'utypi02',
    //loadComponent: () => import('./utypi02/utypi02Pkg.component').then(m => m.Utypi02Component),
    component: Utypi02BillComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'utypi03',
    //loadComponent: () => import('./utypi02/utypi02Pkg.component').then(m => m.Utypi02Component),
    component: Utypi03BillComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'utyq01',
    //loadComponent: () => import('./utyq01/utyq01.component').then(m => m.Utyq01Component),
    component: Utyq01Component,
    canActivate: [AuthGuardService],
  },
  {
    path: 'utypq01',
    //loadComponent: () => import('./utypq01/utypq01.component').then(m => m.Utypq01Component),
    component: Utypq01Component,
    canActivate: [AuthGuardService],
  },
  {
    path: 'utypq03',
    //loadComponent: () => import('./utypq01/utypq01.component').then(m => m.Utypq01Component),
    component: Utypq03Component,
    canActivate: [AuthGuardService],
  },
];

